import React from 'react';
import clsx from 'clsx';
import BasicHead from 'browser/components/BasicHead';
import { ProtocolWarningModal } from 'browser/components/ProtocolWarningModal';
import { NewVersionBanner } from '../NewVersionBanner';
import SbBrandGradient from 'shared/assets/images/sb-brand-gradient.svg';
import { NavBar } from '../NavBar';
import { useAppSelector } from 'shared/store';
import './style.less';
import { TourBanner } from 'browser/components/TourBanner';
import { selectIsTouring } from 'shared/store/tour-slice';

export interface TemplateProps {
  /** The title that's shown in the web browser tab */
  title: string;
  isFullScreen?: boolean;
  isWhite?: boolean;
  hideHeader?: boolean;
}

export const Template: React.FC<TemplateProps> = ({
  title,
  isFullScreen,
  isWhite,
  hideHeader,
  children,
}) => {
  return (
    <>
      <BasicHead title={title} />
      <SbBrandGradient style={{ position: 'absolute', pointerEvents: 'none' }} />
      <div className={clsx('Template', isWhite && 'is-white')}>
        {!isFullScreen && !hideHeader && <NavBar />}
        <div className="Template__content">{children}</div>
      </div>
      <ProtocolWarningModal />
      <NewVersionBanner />
    </>
  );
};

export const TemplateSidebar: React.FC<{ className?: string }> = ({
  children,
  className,
}) => {
  const templateSidebar = useAppSelector(s => s.dashboard.templateSidebar);
  return (
    <div
      className={clsx(
        'Template__content-sidebar',
        templateSidebar !== 'list' && 'Template__content-sidebar--hidden',
        className,
      )}
    >
      {children}
    </div>
  );
};

interface TemplateMainProps {
  padding?: 'none' | 'default' | 'large';
}

export const TemplateMain: React.FC<TemplateMainProps> = ({
  children,
  padding = 'large',
}) => {
  const isTouring = useAppSelector(selectIsTouring);

  return (
    <>
      <div
        className={clsx(
          'Template__content-main',
          `Template__content-main--padding-${padding}`,
          isTouring && `Template__content-main--tour`,
        )}
      >
        {children}
      </div>
      {isTouring && <TourBanner />}
    </>
  );
};
